// const cookiesButton = document.querySelector('.cookies__close');
// if (cookiesButton) {
//     cookiesButton.addEventListener('click', e => {
//         document.querySelector('.cookies').classList.remove('open');
//     });
// }

(function() {
    const COOKIE_CONSENT_KEY = 'astons_cookie_consent';
    const COOKIE_CONSENT_VALUE = 'accepted';
    const COOKIE_EXPIRY_DAYS = 365; // Срок действия согласия - 1 год
    
    const cookieBanner = document.getElementById('cookie-banner');
    const closeButton = document.getElementById('cookie-close-btn');
    
    if (!cookieBanner || !closeButton) return;
    
    // Функция для проверки согласия
    function hasConsent() {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) return false;
        
        try {
            const consentData = JSON.parse(consent);
            const now = new Date().getTime();
            
            // Проверяем, не истекло ли согласие
            if (consentData.expiry && now > consentData.expiry) {
                localStorage.removeItem(COOKIE_CONSENT_KEY);
                return false;
            }
            
            return consentData.value === COOKIE_CONSENT_VALUE;
        } catch (e) {
            // Если ошибка парсинга, удаляем и возвращаем false
            localStorage.removeItem(COOKIE_CONSENT_KEY);
            return false;
        }
    }
    
    // Функция для сохранения согласия
    function saveConsent() {
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);
        
        const consentData = {
            value: COOKIE_CONSENT_VALUE,
            date: new Date().getTime(),
            expiry: expiryDate.getTime()
        };
        
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData));
    }
    
    // Функция для скрытия плашки
    function hideBanner() {
        cookieBanner.classList.remove('open');
        // Удаляем плашку из DOM через небольшую задержку для плавной анимации
        setTimeout(function() {
            cookieBanner.style.display = 'none';
        }, 300);
    }
    
    // Функция для показа плашки
    function showBanner() {
        cookieBanner.style.display = '';
        // Небольшая задержка для корректной работы анимации
        setTimeout(function() {
            cookieBanner.classList.add('open');
        }, 10);
    }
    
    // Проверяем согласие при загрузке страницы
    if (hasConsent()) {
        // Если согласие уже есть, скрываем плашку
        cookieBanner.classList.remove('open');
        cookieBanner.style.display = 'none';
    } else {
        // Если согласия нет, показываем плашку
        showBanner();
    }
    
    // Обработчик клика на кнопку закрытия
    closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Сохраняем согласие
        saveConsent();
        
        // Скрываем плашку
        hideBanner();
    });
    
    // Также можно закрывать при клике на ссылку в тексте (опционально)
    const cookieLink = cookieBanner.querySelector('a');
    if (cookieLink) {
        cookieLink.addEventListener('click', function(e) {
            // Не предотвращаем переход по ссылке, но можно добавить логику если нужно
        });
    }
})();
        
